import React from "react";
import { Link } from "react-router-dom";

export default function ErrorNotFound() {
  return (
    <div
      className="notFoundContainer"
      style={{ marginLeft: 30, marginTop: 30 }}
    >
      <h2> nothin' to see here... </h2>
      <p>
        <Link to="/">&#60; back to the homepage</Link>
      </p>
    </div>
  );
}
